import axios from "axios";
import { IClientType } from "../Types/account";
import { getUserFromLS } from "../utils/getUserFromLS";

export const getAllClientTypes = (callback: (response: IClientType[]) => void, errorCallback) => {
    const user = getUserFromLS()
    const URL = `${import.meta.env.VITE_API_BASE_URL}/clients/`;
    return axios(URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${user.access_token}`
      }
    })
        .then((response) => {
        if (callback != null) {
            callback(response.data as IClientType[]);
        }
        })
        .catch((error) => {
        // catch error
        if (errorCallback != null) {
            errorCallback(error);
        }
    });
};
